import axiosClient from "./axiosClient";

const url = "/auth";

export const authApi = {
  login(body) {
    return axiosClient.post(`${url}/login`, body);
  },
  register(body) {
    return axiosClient.post(`${url}/register`, body);
  },
  sendOtp(body) {
    return axiosClient.post(`${url}/send-otp`, body);
  },
  verifyOtp(body) {
    return axiosClient.post(`${url}/verify-otp`, body);
  },
  getProfile() {
    return axiosClient.get(`${url}/me`);
  },
  updateProfile(body) {
    return axiosClient.put(`${url}/me`, body);
  },

  forgotPassword(body) {
    return axiosClient.post(`${url}/forgot-password`, body);
  },
  resetPassword(body) {
    return axiosClient.post(`${url}/reset-password`, body);
  },
};
